import React, { useState } from 'react';
import StepImageModal from './StepImageModal';

type StepImageProps = {
  src: string;
  alt: string;
  title?: string;
};

const StepImage: React.FC<StepImageProps> = ({ src, alt, title }) => {
  const [open, setOpen] = useState(false);
  const [errored, setErrored] = useState(false);

  if (!src) return null;

  return (
    <div className="mt-3">
      {errored ? (
        <div className="rounded-xl border border-dashed border-[#E7D9B8] bg-[#FFFCF5] p-4 text-xs text-slate-600">
          <p className="font-semibold text-slate-700">Image failed to load</p>
          <p className="mt-1">The screenshot could not be displayed here.</p>
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex text-xs font-semibold text-[#A7854F] underline"
          >
            Open in new tab
          </a>
        </div>
      ) : (
        <button
          type="button"
          className="w-full overflow-hidden rounded-xl border border-[#E7D9B8] bg-white shadow-[0_10px_24px_-18px_rgba(15,23,42,0.35)] transition hover:-translate-y-0.5"
          onClick={() => setOpen(true)}
        >
          <img
            src={src}
            alt={alt}
            className="w-full max-h-[140px] object-cover"
            loading="lazy"
            onError={() => setErrored(true)}
          />
        </button>
      )}
      <div className="mt-2">
        <a
          href={src}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-semibold text-[#A7854F] underline"
        >
          Open image
        </a>
      </div>
      <StepImageModal
        open={open}
        onClose={() => setOpen(false)}
        src={src}
        alt={alt}
        title={title}
      />
    </div>
  );
};

export default StepImage;
